import { useContext, useEffect } from "react";
import { SignFormContext } from "../SignForm";
import { Card, Col, FormLabel, Row, Button } from "react-bootstrap";
import Select from "react-select";
import { addDefaultOption } from "../../../../../utils/utility";
import useUploadDocumentFormPayload from "../../../Sales/Invoice/UploadDocuments/form/hooks/useUploadDocumentFormPayload";
import useSignFormPayload from "../form/hooks/useSignFormPayload";

export default function FormTemplateSelection() {
    const {
        batchData,
        pdfTemplateDropdownData,
        studentDropdownData,
        handleTemplateSelection,
        handleStudentSelection,
        s3Link, setS3Link,
    } = useSignFormPayload();

    const handleOpenAndCopyLink = async () => {
        if (!s3Link) return;

        try {
            // Open link in new tab
            window.open(s3Link, '_blank');
            
            // Copy to clipboard
            await navigator.clipboard.writeText(s3Link);
            
            // Optional: Show success message or notification
        } catch (err) {
            console.error('Failed to copy link: ', err);
            
            // Fallback for older browsers
            try {
                const textArea = document.createElement('textarea');
                textArea.value = s3Link;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            } catch (fallbackErr) {
                console.error('Fallback copy failed: ', fallbackErr);
            }
        }
    };

    return <Card className="">
        <Card.Body>
            <Row>
                <Col>
                    <FormLabel>Class Name</FormLabel>
                    <h5>{batchData?.name ?? ''}</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormLabel>Forms</FormLabel>
                    <Select
                        isClearable
                        options={addDefaultOption(pdfTemplateDropdownData ?? [])}
                        onChange={handleTemplateSelection}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormLabel>Student</FormLabel>
                    <Select
                        isClearable
                        options={addDefaultOption(studentDropdownData ?? [])}
                        onChange={handleStudentSelection}
                    />
                </Col>
            </Row>
            
            {/* S3 Link Section with Button */}
            {s3Link && (
                <Row className="mt-3">
                    <Col>
                        <div className="d-flex align-items-center gap-2">
                            <Button 
                                variant="primary" 
                                size="sm"
                                onClick={handleOpenAndCopyLink}
                                className="d-flex align-items-center gap-1"
                            >
                                Open & Copy Sharable PDF Link
                            </Button>
                        </div>
                    </Col>
                </Row>
            )}
        </Card.Body>
    </Card>
}